import React, { useEffect, useState } from "react";
import { useAuth } from "../lib/auth";
import { useNavigate } from "react-router-dom";
import SeekerDashboard from "./dashboards/SeekerDashboard";
import ProviderDashboard from "./dashboards/ProviderDashboard";
import CaseManagerDashboard from "./dashboards/CaseManagerDashboard";
import AdminDashboard from "./dashboards/AdminDashboard";

export default function Dashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!user) navigate("/login");
    else setReady(true);
  }, [user, navigate]);

  if (!ready) return null;
  if (user.role === "seeker") return <SeekerDashboard />;
  if (user.role === "provider") return <ProviderDashboard />;
  if (user.role === "case_manager" || user.role === "agency_owner" || user.role === "agency_staff") return <CaseManagerDashboard />;
  if (user.role === "admin" || user.role === "super_admin") return <AdminDashboard />;
  return <div className="p-12 text-center">Unknown role</div>;
}
